module.exports = __webpack_public_path__ + "static/media/Step2.b8161c8d.png";